import { Component, ChangeDetectionStrategy } from '@angular/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmTypographyImports } from '@spartan-ng/helm/typography';
import { LogoComponent } from '../../logo/logo.component';

@Component({
  selector: 'app-footer',
  imports: [HlmButtonImports, HlmTypographyImports, LogoComponent],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class FooterComponent {
  readonly legalLinks = [
    { label: 'AGB', href: 'https://www.schenkwerk.com/agbs' },
    { label: 'Datenschutz', href: 'https://www.schenkwerk.com/datenschutz' },
    { label: 'Impressum', href: 'https://www.schenkwerk.com/impressum' },
  ];

  /** Keeps the copyright from going stale. */
  readonly currentYear = new Date().getFullYear();
}
